export async function runCartPreBook(api, confirmWarnings) {
    const preBook = await readPreBookResult(api, '/Cart/PreBook', {});
    if (!preBook.confirmationId)
        return true;

    if (preBook.hotels?.some(hotel => hotel.warnings?.length) && !await confirmWarnings(preBook.hotels))
        return false;

    await readPreBookResult(api, '/Cart/ConfirmPreBook', { confirmationId: preBook.confirmationId });
    return true;
}

async function readPreBookResult(api, url, data) {
    const result = await api('post', url, data);
    if (result.errors?.length || !result.response)
        throw new Error(result.errors?.join('\n') || 'Не удалось проверить условия бронирования.');
    if (result.response.hasErrors)
        throw new Error(result.response.genericError || 'Не удалось проверить условия бронирования.');
    return result.response;
}
